import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'tr' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('edgeMarine_language', newLang);
    document.documentElement.lang = newLang;
  };

  return (
    <button
      onClick={toggleLanguage}
      className="language-switcher"
      aria-label="Switch language"
    >
      <Globe size={18} />
      <span>{i18n.language === 'en' ? 'TR' : 'EN'}</span>
    </button>
  );
};

export default LanguageSwitcher;
